import '$lib/i18n'
import { locale, waitLocale } from 'svelte-i18n'

/** @type {import('./$types').LayoutLoad} */
export const load = async ({ params }) => {
    locale.set(params.locale)
    await waitLocale()
}
